import Medusa from '@adoratorio/medusa';
import enterInView from './enterInView';

const medusa = new Medusa();
const viewport = document.querySelector('.app');
medusa.addObserver(enterInView(viewport));

export { medusa };